module.exports = __webpack_public_path__ + "img/right-arrow-white.a8438fc6.svg";